export default __webpack_public_path__ + "static/media/Payment.86934c7c.jpg";